"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.address = void 0;
exports.address = {
    line1: '807 Broadway St NE',
    line2: '#300',
    city: 'Minneapolis',
    state: 'MN',
    zip: '55413',
    country: 'United States',
};
